<template>
    <div class="account">
        <div class="top_header_fixed">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/parameterList' }">参数</el-breadcrumb-item>
                <el-breadcrumb-item>{{ headerTitle }}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="title_btn">
                <div>
                    <el-button size="small" plain @click="addNews">新增</el-button>
                    <el-button size="small" plain @click="copy">复制</el-button>
                    <el-button size="small" plain @click="editDetails">编辑</el-button>
                    <el-button size="small" plain @click="amend(list.id)">删除</el-button>
                </div>
            </div>
        </div>

        <div class="main_list">
            <el-collapse v-model="activeNames">
                <el-collapse-item disabled title="基本信息" name="1">
                    <el-form label-position="right" :model="list" class="details" label-width="auto">
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="code："> {{ list.code }}</el-form-item></el-col
                            >
                            <el-col :span="12">
                                <el-form-item label="名称：">
                                    {{ list.name }}
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="值：">
                                    {{ list.value }}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="备注：">
                                    {{ list.remark }}
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row>
               
                            <el-col :span="12">
                                <el-form-item label="创建人：" prop="created_by">
                                    <div class="read_only">{{ list.created_by ? list.created_by : '' }}</div></el-form-item></el-col>



                            <el-col :span="12">
                                <el-form-item label="上次修改人：" prop="updated_by">
                                    <div class="read_only">{{ list.updated_by ? list.updated_by : '' }} </div></el-form-item></el-col>

                                   
                        </el-row>
                    </el-form>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
export default {
    inject: ['reload'],
    name: 'parameterDetail',
    data() {
        return {
            list: {},
            activeNames: ['1'],
            rid: '',
            headerTitle: '参数详情'
        };
    },
    watch: {
        $route(to, from) {
            this.rid = to.query.id;
            this.reload();
        }
    },
    mounted() {
        this.rid = this.$route.query.id;
        this.getDetails(); //获取详情
    },
    methods: {
        //删除当前行
        amend(id) {
            var params = {
                id: id
            };
            let messages = '此操作将删除此条数据，是否继续?';
            this.$msgbox({
                title: '消息',
                message: messages,
                showCancelButton: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                closeOnPressEscape: false,
                closeOnClickModal: false,
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        instance.confirmButtonLoading = true;
                        instance.confirmButtonText = '删除...';
                        this.$api
                            .parametertDelete(params)
                            .then((res) => {
                                done();
                                setTimeout(() => {
                                    instance.confirmButtonLoading = false;
                                }, 300);
                                if (res.code == 0) {
                                    this.$message({
                                        showClose: true,
                                        message: '删除成功',
                                        type: 'success'
                                    });
                                    this.$bus.$emit('fullPath', this.$route.fullPath);
                                    this.$router.push({
                                        path: '/parameterList'
                                    });
                                }
                            })
                            .catch((error) => {
                                done();
                                setTimeout(() => {
                                    instance.confirmButtonLoading = false;
                                }, 300);
                            });
                    } else {
                        done();
                    }
                }
            })
                .then((action) => action)
                .catch((error) => error);
        },
        //前往编辑页面
        editDetails() {
            this.$router.push({
                path: 'parameterEdit',
                query: {
                    type: 1,
                    id: this.rid
                }
            });
        },
        //新增
        addNews() {
            this.$router.push({
                path: 'parameterEdit',
                query: {
                    type: 3,
                    id: this.rid
                }
            });
        },
        //复制页面
        copy() {
            this.$router.push({
                path: 'parameterEdit',
                query: {
                    type: 5,
                    id: this.rid
                }
            });
        },
        //取消
        cancel() {
            if (window.history.length <= 1) {
                this.$router.push({ path: '/parameterList' });
            } else {
                this.$router.go(-1);
            }
        },
        //合作方详情
        getDetails() {
            let params = {
                rid: this.rid
            };
            this.$api
                .parameterDetail(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.list = res.data;
                        document.title = this.headerTitle + ':' + res.data.code;
                    }
                })
                .catch((error) => {});
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
</style>